<!-- User Detail Dialog
  Uses PrimeNG p-dialog with custom styling
  Positioned on right side with full height
  Shows user information in read-only mode
-->
<p-dialog
	[(visible)]="visible"
	[draggable]="false"
	[resizable]="false"
	[modal]="true"
	[closable]="true"
	[closeOnEscape]="true"
	[closeAriaLabel]="'common.actions.close' | transloco"
	[header]="'users.detail.header' | transloco"
	[appendTo]="'body'"
	[styleClass]="'user-dialog'"
>
	<!-- Custom header template with subtitle and title -->
	<ng-template pTemplate="header">
		<div class="dialog-header" [attr.data-subtitle]="'users.detail.subtitle' | transloco">
			<span class="dialog-title">{{ 'users.detail.title' | transloco }}</span>
		</div>
	</ng-template>

	<!-- User Detail Content -->
	<div class="detail-container">
		<div class="detail-group">
			<!-- Name Section -->
			<div class="detail-field">
				<label class="detail-label">{{ 'users.detail.fields.fullName' | transloco }}</label>
				<p class="detail-value">{{ user?.name || '-' }} {{ user?.lastName || '' }} {{ user?.lastName2 || '' }}</p>
			</div>

			<!-- Email Field -->
			<div class="detail-field">
				<label class="detail-label">{{ 'users.detail.fields.email' | transloco }}</label>
				<p class="detail-value">{{ user?.email || '-' }}</p>
			</div>

			<!-- Phone Field -->
			<div class="detail-field">
				<label class="detail-label">{{ 'users.detail.fields.phone' | transloco }}</label>
				<p class="detail-value">{{ (user?.phone | phoneFormat) || '-' }}</p>
			</div>

			<!-- Role Row -->
			<div class="detail-field-row">
				<div class="detail-field">
					<label class="detail-label">{{ 'users.detail.fields.role' | transloco }}</label>
					<p class="detail-value">{{ user?.roleName || '-' }}</p>
				</div>
			</div>

			<!-- Status Field -->
			<div class="detail-field">
				<label class="detail-label">{{ 'users.detail.fields.status' | transloco }}</label>
				<p class="detail-value">{{ user?.bannedText || '-' }}</p>
			</div>

			<!-- Supabase User ID Field -->
			<div class="detail-field">
				<label class="detail-label">{{ 'users.detail.fields.supabaseUserId' | transloco }}</label>
				<p class="detail-value detail-value-code">{{ user?.supabaseUserId || '-' }}</p>
			</div>
		</div>

		<!-- Action Buttons -->
		<div class="detail-actions">
			<app-button
				[label]="'users.detail.actions.edit' | transloco"
				variant="secondary"
				(click)="onEdit()"
				size="medium"
			></app-button>

			@if (user?.banned) {
				<!-- If user is banned, show Activate and Delete Permanently buttons -->
				<app-button
					[label]="'users.detail.actions.activate' | transloco"
					variant="primary"
					(click)="onUnban()"
					size="medium"
				></app-button>
				<app-button
					[label]="'users.detail.actions.deletePermanently' | transloco"
					variant="tertiary"
					(click)="onDeletePermanently()"
					size="medium"
					class="button-delete"
				></app-button>
			} @else {
				<!-- If user is active, show Block (ban: reversible, nothing is deleted) -->
				<app-button
					[label]="'users.detail.actions.block' | transloco"
					variant="tertiary"
					(click)="onBlock()"
					size="medium"
					class="button-delete"
				></app-button>
			}
		</div>
	</div>
</p-dialog>
